import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class StoreService {

  constructor(private auth: AuthService, private appConstants: AppConstants, private http: HttpClient) {
  }

  getAllStores(): Observable<any> {
    const url = environment.apiBase + 'all_stores';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getStore(id: string): Observable<any> {
    const url = environment.apiBase + 'stores/' + id;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  registerStore(body): Observable<any> {
    const url = environment.apiBase + 'stores';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  updateStore(body): Observable<any> {
    const url = environment.apiBase + 'stores/' + body.id;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store.service.ts